import React, { useContext } from "react";
import MuiTabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import cx from "classnames";

import { ThemeContextNuO } from "../nuorder-theme";
import { useStyles } from "./tabs.styles";
import type { TVariants } from "../types";

type TTabProps = {
    value: number;
    labels: { label: string; disabled?: boolean; onClick?: () => void }[];
    variant?: Extract<TVariants, "primary">;
    onTabChange: (event: React.ChangeEvent<{}>, newValue: number) => void;
};

export const Tabs = ({ variant = "primary", ...props }: TTabProps) => {
    const themeContextNuO = useContext(ThemeContextNuO);
    const styles = useStyles(themeContextNuO);

    const styleActiveTab = { backgroundColor: themeContextNuO.tabs[variant]?.activeTab?.borderColor /* zIndex: 1 */ };

    return (
        <MuiTabs
            TabIndicatorProps={{ style: styleActiveTab }}
            value={props.value}
            onChange={props.onTabChange}
            className={cx(styles.tabsContainer, styles[`${variant}TabsVariant`])}
        >
            {props.labels.map(({ label, disabled, onClick }, idx) => (
                <Tab
                    key={`REUSABLE_TAB_ID_${label}_${idx}`}
                    label={label}
                    value={idx}
                    disabled={disabled}
                    className={cx(styles.tab, styles[`${variant}TabVariant`])}
                    onClick={onClick}
                />
            ))}
        </MuiTabs>
    );
};
